var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Header'),_c('TippGrid'),_c('Footer'),_c('LanguageSwitch',{staticClass:"lang-switch"}),_c('the-cookie-banner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }